module.exports = __webpack_public_path__ + "static/media/transfer-exchange-icon.9998afa0.svg";